import { ZoneType } from "./GridTile";

export class TrayState {
    color: number;
    type: ZoneType;
    
    public static ROADS: TrayState = {
        color: 0x5cffa2,
        type: "roads"
    };

    public static COMMERCIAL: TrayState = {
        color: 0x7fffff,
        type: "commercial"
    };

    public static INDUSTRIAL: TrayState = {
        color: 0xe3ca31,
        type: "industrial"
    };

    public static RESIDENTIAL: TrayState = {
        color: 0xca3f52,
        type: "residential"
    };

    public static TRAYSTATES: TrayState[] = [TrayState.ROADS, TrayState.COMMERCIAL, TrayState.INDUSTRIAL, TrayState.RESIDENTIAL];
}



// WEBPACK FOOTER //
// ./src/games/CityBuilderGame/objects/TrayState.ts